import { Link } from "react-router-dom";
import { categories, mainSiteUrl } from "@/mocks/categories";

const formSubmitAddr = "https://readdy.ai/api/form/d90dmcq181e9e92u92v0";

export default function Footer() {
  return (
    <footer className="w-full bg-primary-500 rounded-t-3xl mt-8">
      <div className="max-w-6xl mx-auto px-6 md:px-10 pt-16 pb-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12 mb-12">
          <div>
            <h3 className="text-xl md:text-2xl font-bold text-background-50 mb-4 font-heading whitespace-nowrap">
              Smarter Sourcing
              <br />
              Starts Here.
            </h3>
            <p className="text-sm text-background-50/60 leading-relaxed">
              ItaobuySpreadsheet is a next-generation product sourcing system built for dropshippers, Amazon sellers, and global eCommerce buyers.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 whitespace-nowrap">Categories</h4>
            <ul className="space-y-2">
              {categories.map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 whitespace-nowrap">Shopping Guide</h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/guides/what-is-itaobuy-sheet"
                  className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer"
                >
                  What Is Itaobuy Sheet
                </Link>
              </li>
              <li>
                <Link
                  to="/guides/how-to-source-products-with-spreadsheets"
                  className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer"
                >
                  How to Source with Spreadsheets
                </Link>
              </li>
              <li>
                <Link
                  to="/guides/dropshipping-spreadsheet-guide"
                  className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Dropshipping Spreadsheet Guide
                </Link>
              </li>
              <li>
                <Link
                  to="/guides/china-sourcing-spreadsheet-tips"
                  className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer"
                >
                  China Sourcing Tips
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 whitespace-nowrap">Stay Updated</h4>
            <p className="text-sm text-background-50/60 mb-4 leading-relaxed">
              Subscribe for dropshipping updates and new product sheet alerts.
            </p>
            <form
              data-readdy-form=""
              method="POST"
              action={formSubmitAddr}
              className="flex"
            >
              <input
                type="email"
                name="email"
                placeholder="Your email"
                required
                className="flex-1 px-4 py-3 text-sm bg-background-50/10 border border-background-50/20 rounded-l-full text-background-50 placeholder:text-background-50/40 focus:outline-none focus:border-background-50/40"
              />
              <input
                type="text"
                name="phone_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                className="honeypot-field"
              />
              <button
                type="submit"
                className="px-4 py-3 bg-background-50 text-primary-500 rounded-r-full hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
              >
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-arrow-right-line text-lg"></i>
                </span>
              </button>
            </form>
          </div>
        </div>

        <div className="relative border-t border-background-50/10 pt-8">
          <div className="absolute inset-0 flex items-center justify-center overflow-hidden pointer-events-none select-none">
            <span className="text-[120px] md:text-[180px] font-bold text-background-50/[0.03] font-heading whitespace-nowrap leading-none">
              ITAOBUY
            </span>
          </div>
          <div className="relative flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-50/40 whitespace-nowrap">
              &copy; {new Date().getFullYear()} Itaobuy. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="text-xs text-background-50/40 hover:text-background-50/70 transition-colors whitespace-nowrap cursor-pointer"
              >
                Privacy
              </a>
              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="text-xs text-background-50/40 hover:text-background-50/70 transition-colors whitespace-nowrap cursor-pointer"
              >
                Terms
              </a>
              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="text-xs text-background-50/40 hover:text-background-50/70 transition-colors whitespace-nowrap cursor-pointer"
              >
                Contact
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}